module.exports = __webpack_public_path__ + "static/media/HTC One A9 Black.84bd8d94.png";